import { mergeClasses } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'
import { useLoadingBubbleStyles } from './ChatBubble.styles'

const LoadingBubble = () => {
  const styles = useLoadingBubbleStyles()
  const { t } = useTranslation()

  return (
    <div className={styles.container} role="status" aria-label={t('loading')}>
      <span className={mergeClasses(styles.dot, styles.dot1)} />
      <span className={mergeClasses(styles.dot, styles.dot2)} />
      <span className={mergeClasses(styles.dot, styles.dot3)} />
    </div>
  )
}

export { LoadingBubble }
